import "../styles/ticket-home.css";
import { useState, useEffect } from "react";
import { Skeleton } from "primereact/skeleton";
import OffPlusController from "../services/offplus-controller";
import { PrimeIcons } from "primereact/api";

export default function TicketHome(props) {
	const offPlusController = new OffPlusController();
	const [isLoading, setIsLoading] = useState(false);
	const [states, setStates] = useState([]);
	const [cities, setCities] = useState([]);
	const [stores, setStores] = useState([]);
	const [productModels, setProductModels] = useState([]);
	const [pageType, setPageType] = useState("states");
	const [stateName, setStateName] = useState("");
	const [cityName, setCityName] = useState("");
	const [storeName, setStoreName] = useState("");

	useEffect(() => {
		getData();
	}, []);

	const getData = async function () {
		try {
			setIsLoading(true);
			const result = await offPlusController.getActiveStates();
			if (result.isSuccess === false) throw result.message;
			setStates(result.value);
		} catch (error) {
			alert(error.toString());
		} finally {
			setIsLoading(false);
		}
	};

	//> viewCities
	const viewCities = async function (state) {
		try {
			setIsLoading(true);
			setStateName(state.name);
			const result = await offPlusController.getActiveCities(state.stateId);
			if (result.isSuccess === false) throw result.message;
			setCities(result.value);
			setPageType("cities");
		} catch (error) {
			alert(error.toString());
		} finally {
			setIsLoading(false);
		}
	};

	//> viewStores
	const viewStores = async function (city) {
		try {
			setIsLoading(true);
			setCityName(city.name);
			const result = await offPlusController.getActiveStores(city.cityId);
			if (result.isSuccess === false) throw result.message;
			setStores(result.value);
			setPageType("stores");
		} catch (error) {
			alert(error.toString());
		} finally {
			setIsLoading(false);
		}
	};

	//> viewProductModels
	const viewProductModels = async function (store) {
		try {
			setIsLoading(true);
			setStoreName(store.name);
			const result = await offPlusController.getActiveProductModels(
				store.storeId
			);
			if (result.isSuccess === false) throw result.message;
			setProductModels(result.value);
			setPageType("productModels");
		} catch (error) {
			alert(error.toString());
		} finally {
			setIsLoading(false);
		}
	};
	//>
	return (
		<div className="tickets">
			{isLoading === true && (
				<>
					<div className="flex gap-4 mb-4">
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
					</div>
					<div className="flex gap-4 mb-4">
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
					</div>
					<div className="flex gap-4 mb-4">
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
					</div>
				</>
			)}
			{isLoading === false && (
				<>
					{pageType === "states" && (
						<>
							<h3>
								<span>استان را انتخاب کنید</span>
							</h3>
							<ul>
								{states.map((item) => (
									<li>
										<a onClick={() => viewCities(item)}>
											<img src={item.imageUrl} alt="" />
											<h2>{item.name}</h2>
										</a>
									</li>
								))}
							</ul>
						</>
					)}
					{pageType === "cities" && (
						<>
							<h3>
								<span>استان {stateName}</span>
								<i className={PrimeIcons.ANGLE_LEFT}></i>
								<span>یک شهر را انتخاب کنید</span>
							</h3>

							<ul>
								{cities.map((item) => (
									<li>
										<a onClick={() => viewStores(item)}>
											<img src={item.imageUrl} alt="" />
											<h2>{item.name}</h2>
										</a>
									</li>
								))}
							</ul>
						</>
					)}

					{pageType === "stores" && (
						<>
							<h3>
								<span>استان {stateName}</span>
								<i className={PrimeIcons.ANGLE_LEFT}></i>
								<span>شهر {cityName}</span>
								<i className={PrimeIcons.ANGLE_LEFT}></i>
								<span>مجموع ورزشی را انتخاب کنید</span>
							</h3>
							<ul>
								{stores.map((item) => (
									<li>
										<a onClick={() => viewProductModels(item)}>
											<img src={item.imageUrl} alt="" />
											<h2>{item.name}</h2>
										</a>
									</li>
								))}
							</ul>
						</>
					)}
					{pageType == "productModels" && (
						<>
							<h3>
								<span>استان {stateName}</span>
								<i className={PrimeIcons.ANGLE_LEFT}></i>
								<span>شهر {cityName}</span>
								<i className={PrimeIcons.ANGLE_LEFT}></i>
								<span>{storeName}</span>
								<i className={PrimeIcons.ANGLE_LEFT}></i>
								<span>نوع خدمات را انتخاب کنید</span>
							</h3>
							<ol>
								{productModels.map((item) => (
									<li>
										<a href={"/#/ticket-buy/?id=" + item.productModelId}>
											<img src={item.imageUrl} alt="" />
											<h2>
												{item.productName} : {item.modelName}
											</h2>
											<div className="t-price">
												<span>{item.unitCost.toLocaleString("fa-IR")}</span>
												<b>{item.offPercent} %</b>
												<strong>
													{(
														item.unitCost -
														item.offPercent * item.unitCost * 0.01
													).toLocaleString("fa-IR")}{" "}
													ریال
												</strong>
											</div>
										</a>
									</li>
								))}
							</ol>
						</>
					)}
				</>
			)}
		</div>
	);
}
